import React, { useRef } from "react";
import { BackButton } from "../../../components/micro";
import { headChat } from "../../../assets/image";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createServicesRequest } from "../../../redux/serviceRequest/slice";

const CloseBankAccount = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const user_id = location?.state?.user_id;
  const company_id = location?.state?.company_id;
  const service = location?.state?.service;
  const buttonRef = useRef(null);

  // Selector
  const createServicesRequestData = useSelector(
    (store) => store?.serviceRequestData?.createServicesRequestStatus?.data
  );
  const createServicesRequestLoading = useSelector(
    (store) => store?.serviceRequestData?.loading
  );

  // Proceed with request
  const handleProceed = () => {
    const payload = {
      details: [],
      amount:
        service?.service_requests_count < service?.detail?.no_of_free_request
          ? 0
          : service?.detail?.price,
      user_id: user_id,
      company_id: company_id,
      service_id: service?.id,
    };
    dispatch(createServicesRequest(payload)).then((res) => {
      if (res.type !== "createServicesRequest/fulfilled") return;
      const { service_requests_count, detail } = service || {};
      const price = detail?.price || 0;
      if (
        service_requests_count < service?.detail?.no_of_free_request ||
        price <= 0
      ) {
        navigate("/approver");
      } else if (buttonRef.current) {
        buttonRef.current.click();
      } else {
        navigate("/approver");
      }
    });
  };

  return (
    <>
      <div className="space-y-5">
        <BackButton
          onClick={() => {
            navigate("/service");
          }}
        />
        {/* Payment Button */}
        <a
          className="hidden"
          ref={buttonRef}
          href={createServicesRequestData?.data?.url}
        >
          Pay Now
        </a>
        <div className="flex items-center space-x-5 border-b-2 border-secondary_grey pb-7">
          <img src={headChat} alt="img" />
          <div className="space-y-2 font-ebGaramond">
            <p className="text-xl">We see that you will need a request on:</p>
            <p className="text-3xl">Close Bank Account</p>
          </div>
        </div>
        <div className="space-y-3 border-b-2 border-secondary_grey pb-4">
          <p className="text-2xl font-ebGaramond">
            Let us guide u though the process:
          </p>
          <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
            <span>1.</span>
            <p>SGCorpHub will create relevant documents</p>
          </div>
          <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
            <span>2.</span>
            <p>Signed the relevant doucments</p>
          </div>
          <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
            <span>3.</span>
            <p>Bring signed banks closure resolution to bank for closure</p>
          </div>
          <p className="text-sm">
            Once the request is opened. You can easily manage it over at
            “On-Going” service page.
          </p>
        </div>
        <div className="flex items-center justify-between space-x-1  bg-light_primary_shades rounded-lg px-4 py-3">
          <p className="font-semibold">Total Payable :</p>
          <div>
            <p className="text-xs">
              {service?.service_requests_count}/
              {service?.detail?.no_of_free_request ?? 0} used
            </p>
            <p>
              {service?.service_requests_count >=
              service?.detail?.no_of_free_request
                ? `$${service?.detail?.price}`
                : "Free"}
            </p>
          </div>
        </div>
        <div className="box !rounded-xl flex items-center justify-between">
          <button
            className={`${
              createServicesRequestLoading
                ? "btn-outline-disabled"
                : "btn-theme"
            } uppercase`}
            onClick={handleProceed}
          >
            {createServicesRequestLoading
              ? "Loading..."
              : "Proceed with request"}
          </button>
          <div>
            <p className="text-xs">Total:</p>
            <p>
              {service?.service_requests_count >=
              service?.detail?.no_of_free_request
                ? `$${service?.detail?.price}`
                : "Free"}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CloseBankAccount;
